/**************************************************
 * Nombre:       Barra_PerfilEmergente
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Divider, Grid, Typography} from "@mui/material";
import {TEXTO} from "../../ContantesColor";
import Tarjeta_Perfil from "./SubComponentes/Tarjeta_Perfil";
import TarjetaSecciones from "../SubComponentes/TarjetaSecciones";
import {useContext} from "react";
import {contexBarra} from "../../../Dashboard/Dashboard";
import {useDialogo} from "../../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Perfil from "../../../Dashboard/Dialogos/Dialogo_Perfil";

const Barra_PerfilEmergente = ({seccionesPerfil, usuario}) => {
    const cData = useContext(contexBarra)
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Perfil, titulo: 'Detalles de perfil'})

    return (
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
            size={12}
            sx={{width: 356, p: 3}}
        >

            <Dialogo/>

            <Grid size={12}>
                <Typography sx={{fontWeight: 600, fontSize: 18, color: TEXTO}}>Perfil de Usuario</Typography>
            </Grid>

            <Grid size={12} sx={{marginTop: 2}}>
                <Tarjeta_Perfil usuario={usuario}/>
            </Grid>

            <Grid item size={12} sx={{marginTop: 3}}>
                <Divider color={'#fcfcfc'} sx={{width: '100%'}}/>
            </Grid>


            <Grid item size={12}>
                {seccionesPerfil.map((item, index) => {
                    return (
                        <Grid item size={12} sx={{marginTop: 2}}>
                            <TarjetaSecciones item={item}/>
                        </Grid>

                    )
                })}
            </Grid>

            <Grid item size={12} sx={{marginTop: 2}}>
                <Button
                    onClick={() => abrir()}
                    fullWidth variant={'contained'}>Editar Perfil</Button>
            </Grid>

            <Grid item size={12} sx={{marginTop: 2}}>
                <Button
                    onClick={() => cData.funSalir()}
                    fullWidth variant={'outlined'}>Cerrar Sesion</Button>
            </Grid>

        </Grid>
    )

}
export default Barra_PerfilEmergente

